<template>
    <div class="mainDiv">
        <v-snackbar
            v-model="snackbar"
            :color="snackbarColor"
            multi-line="multi-line"
            bottom
            vertical="vertical"
        >
            {{ snackbarMessage }}
            <v-btn
                color="white"
                flat
                @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>

        <v-card
            class="cardStyle"
            style="border-radius: 9px;"
        >
            <v-card-title
                primary-title
                style="border: 1px solid black; background-color: #00A4D2; color: white;"
            >
                <div style="width: 100%; display: flex; justify-content: center;">
                    <div
                        class="headline"
                        style="fontWeight: bold; fontSize: 30px;"
                    >
                        SSL Checker
                    </div>
                </div>
            </v-card-title>
            <v-card-actions>
                <div style="display: flex; flex-direction: column; width: 100%; padding-top: 30px;">
                    <div style="display: flex; justify-content: center;">
                        <div class="upload-btn-wrapper">
                            <button class="btn">Select a file</button>
                            <input
                                ref="uploadInput"
                                type="file"
                                @change="onChangeFileUpload()"
                            >
                        </div>
                    </div>
                    <div
                        class="pt-4 pb-4"
                        style="display: flex; justify-content: center;"
                    >
                        OR
                    </div>
                    <div style="display: flex; justify-content: center;">
                        <v-textarea
                            v-model="textarea"
                            solo
                            label="Domains to check"
                        />
                    </div>
                    <div style="padding-top: 15px; display: flex;justify-content: flex-end;">
                        <v-btn
                            style="width: 100%;"
                            color="#00B5F9"
                            :disabled="!validation"
                            @click="uploadFile"
                        >
                            <span style="color: white;">Check domains</span>
                        </v-btn>
                    </div>
                </div>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>
export default {
    data () {
        return {
            file: '',
            snackbar: false,
            snackbarColor: '',
            snackbarMessage: '',
            textarea: ''
        }
    },
    computed: {
        validation () {
            if (this.file || this.textarea) {
                return true
            } else {
                return false
            }
        }
    },

    methods: {
        showSnackbar (color, message) {
            this.snackbar = true
            this.snackbarColor = color
            this.snackbarMessage = message
            setTimeout(() => {
                this.snackbar = false
            }, 2500)
        },
        uploadFile () {
            if (this.file && this.textarea) {
                this.showSnackbar('error', 'Either use File upload or Textarea not both')
                return
            }
            if (this.file) {
                this.$emit('uploadString', this.file)
                localStorage.setItem('data', this.file)
                this.file = ''
            }

            if (this.textarea) {
                this.$emit('uploadString', this.textarea)
                localStorage.setItem('data', this.textarea)
                this.textarea = ''
            }
        },

        text2Binary (string) {
            return string.split('').map(function (char) {
                return char.charCodeAt(0).toString(2)
            }).join(' ')
        },

        onChangeFileUpload () {
            if (this.$refs.uploadInput.files[0].type === 'text/plain') {
                const reader = new FileReader()
                reader.readAsText(this.$refs.uploadInput.files[0])
                let promise = new Promise(function (resolve) {
                    reader.onload = (e) => resolve(e.target.result)
                })
                promise.then((el) => {
                    this.file = el
                })
            } else {
                this.showSnackbar('error', 'File has to be in the .txt format')
            }
        }
    }
}
</script>
<style>
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn {
  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 20px;
  font-weight: bold;
}

.upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
    width: 100%;
}
.mainDiv {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}
.cardStyle {
    width: 600px;
}
</style>
